<script>
    import _ from 'lodash';
    import {onMount} from "svelte";
    import {navigate} from 'svelte-routing';
    import {network, store} from '../stores.js';
    import {chutzpah, list} from '../config.js';
    import {findLinkByParts, send_order_mail} from '../helpers.js';
    import {send_nomdoc} from '../events.js';
    import storage from '../storage.js';
    import KontrSelectSearch from "./KontrSelectSearch.svelte";
    import KontaktSelectSearch from "./KontaktSelectSearch.svelte";

    const user = store('credential', 'getAuth');
    const cart = store('cart-items', '', '[]');
    const cart_data = store('cart-data', '', '{"id": 0, "nomDoc": -1, "nomDocStr": "", "fio": "", "tel": "", "email": "", "address": "", "comment": "", "note": "", "markup_percent": 0, "discount_percent": 0, "tv": -1}');

    const fetchTv = async () => {
        return network.fetch_tv(+$user.idSklad)
    }

    let order_num = '';
    let idKontr = $user.idkontr;

    const handlerEdit = (id) => {
        if (id >= 0) {
            let item = $cart.find((el) => +el.idTovar === id);
            let link = item?.calc?.trim()?.length ? item.calc : findLinkByParts(list, item.title);

            if (!link) {
                return;
            }

            document.querySelector('[data-bs-target="#cartPanel"]').click();

            storage.setItem('calc-edit', id);
            navigate('/loading');
            setTimeout(() => navigate('/calc/' + link, {replace: true}), 50);
        }
    };
    const handlerRemove = (index) => {
        if (index >= 0) {
            $cart = $cart.filter((el, i) => i !== index);
            cart.save($cart);
        }
    };

    const handlerSaveCardData = (e) => {
        if (typeof e !== 'undefined') {
            $cart_data.id = 0
        }

        if (typeof $cart_data === 'object') {
            cart_data.save($cart_data);
        }
    }

    let price_type = 'rozn';
    let is_disabled = false;
    let is_tv_error = false;
    let is_error = false;

    const doCalcDeal = (discount = 0) => {
        if (!discount) {
            $cart_data.discount_percent = discount = Math.floor(Math.random() * 41) + 10; // от 10 до 50%
        }

        if (discount > 0 && discount <= 99) {
            $cart_data.markup_percent = +(100 * (1 / (1 - discount / 100) - 1)).toFixed(2);
        }
    }

    const calcDealPrice = (price) => {
        if ($cart_data.markup_percent > 0) {
            price = price * (1 + $cart_data.markup_percent / 100)
        }
        if ($cart_data.discount_percent > 0 && $cart_data.discount_percent <= 99) {
            price = price * (1 - $cart_data.discount_percent / 100)
        }

        return Math.round(price);
    }

    const handlerFillContact = (data, id) => {
        if (id) {
            const contact = data.find((el) => el.idKontakt === id)

            if (contact) {
                $cart_data.id = id
                $cart_data.fio = contact.nameKontakt
                $cart_data.email = contact.other1Kontakt
                $cart_data.tel = contact.telefonKontakt
                $cart_data.address = contact.adresKontakt

                handlerSaveCardData()
            }
        }
    }

    const handlerSend = async (create_new = true) => {
        is_disabled = true;
        is_error = false;

        const active = document.activeElement;
        if (active && typeof active.blur === 'function') {
            active.blur();
        }

        let failed = false;
        let xml = '<Attributes>';

        _.forEach($cart, (tovar) => {
            const price = calcDealPrice(tovar.price[price_type])

            xml += '<ProductAttribute idTovar="' + tovar.idTovar + '">';
            xml += '<ProductAttributeValue>';
            xml += '<kolvo>' + tovar.quantity + '</kolvo>';
            xml += '<summa>' + price * tovar.quantity + '</summa>';
            xml += '<summaRozn>' + tovar.price.rozn  + '</summaRozn>';
            xml += '<summaDil>' + (isNaN(tovar.price.opt) ? 0 : tovar.price.opt) + '</summaDil>';
            xml += '<sebestoim>' + (isNaN(tovar.price.sebest) ? 0 : tovar.price.sebest) +'</sebestoim>';
            xml += '</ProductAttributeValue>';
            xml += '</ProductAttribute>';
        });

        xml += '</Attributes>';

        try {
            if ($cart_data.tel) {
                let chutzpah_str = '';

                if ($cart_data.markup_percent > 0 || ($cart_data.discount_percent > 0 && $cart_data.discount_percent <= 99)) {
                    chutzpah_str = `chutzpah:${$cart_data.markup_percent}:${$cart_data.discount_percent}`
                }

                let payload = {
                    tovarxml: xml,
                    nameKontakt: $cart_data.fio ?? '',
                    adresKontakt: $cart_data.address ?? '',
                    telefonKontakt: $cart_data.tel ?? '',
                    emailKontakt: $cart_data.email ?? '',
                    komment: $cart_data.comment ?? '',
                    dopInfo: [($cart_data.note ?? ''), chutzpah_str].filter((e) => e.trim().length).join('|'),
                    tipCen: price_type,
                    idKontakt: $cart_data.id ?? 0,
                    nomDoc: $cart_data.nomDoc ?? -1,
                    nomDocStr: $cart_data.nomDocStr ?? '',
                    idSklad: +$user.idSklad,
                    idKontr: +idKontr,
                    userId: +$user.id,
                }

                // точка выдачи
                if ($cart_data.tv >= 0) {
                    const tvs = await fetchTv()
                    const tv = tvs.find((j) => j.id === $cart_data.tv)

                    if (tv) {
                        payload = {
                            ...payload,
                            tv: tv.tv,
                            tvInfo: tv.tvInfo,
                        }
                    }
                } else {
                    if (APP_TYPE === 'plisse-ltd' && parseInt($user.idSklad) === 7) {
                        is_tv_error = true;
                        is_error = true;
                        failed = true;
                        return;
                    }
                }

                let result = await network.get(create_new ? 'viborkaAddApp2' : 'viborkaUpdApp', payload);

                if (result && result.nomDoc) {
                    order_num = result.nomDoc;

                    // отправляем номер документа
                    send_nomdoc(order_num, $cart);

                    // Письмо не блокирует кнопку: на телефоне этот запрос может не завершиться.
                    let mail = {
                        name: $cart_data.fio ?? '',
                        tel: $cart_data.tel ?? '',
                        email: $cart_data.email ?? null,
                        address: $cart_data.address ?? null,
                        admin: $user.email ?? null
                    };
                    if (mail.email) {
                        const mailPayload = send_order_mail(order_num, mail, $cart);
                        network.post('mail', mailPayload).catch((error) => console.error(error));
                    }

                    const popupEl = document.getElementById('order-send');
                    let popup = null;
                    if (popupEl && typeof bootstrap !== 'undefined') {
                        popup = new bootstrap.Modal(popupEl, {focus: false});
                        popup.show();
                    }

                    cart.remove();
                    cart_data.remove();

                    // тригер отправки события
                    setTimeout(() => window.top.postMessage('send_order::' + order_num, '*'), 1500);
                    if (popup) {
                        setTimeout(() => {
                            popup.hide();
                            navigate('/dashboard');
                        }, 1000 * 60);
                    }

                    return;
                }
            }

            is_error = true;
            failed = true;
        } catch (error) {
            console.error(error);
            is_error = true;
            failed = true;
        } finally {
            if (failed) {
                setTimeout(() => {
                    is_disabled = false;
                    is_error = false;
                    is_tv_error = false;
                }, 1000 * 5);
            } else {
                is_disabled = false;
            }
        }
    }

    const handlerClear = () => {
        cart.save([]);
        cart_data.save({});
        storage.removeItem('params');
    };

    onMount(() => {
        if ($user.idtip === '2') {
            price_type = 'opt'
        }
    })
</script>

<!-- App OffCanvas -->
<div class="offcanvas offcanvas-end" tabindex="-1" id="cartPanel">
    <div class="offcanvas-header">
        <h5 id="offcanvas-title" style="font-size: 1.25rem; margin: 0;">Корзина</h5>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
        {#if $cart.length}
            <ul class="nav nav-tabs capsuled mb-1" id="order-tabs" role="tablist">
                <li class="nav-item col-6" role="presentation">
                    <button class="nav-link w-100 active" id="order-tab" data-bs-toggle="tab" data-bs-target="#order" type="button" role="tab" aria-controls="order" aria-selected="true">
                        <i class="fas fa-shopping-cart pe-1"></i>
                        Заказ
                    </button>
                </li>
                <li class="nav-item col-6" role="presentation">
                    <button class="nav-link w-100" id="client-tab" data-bs-toggle="tab" data-bs-target="#client" type="button" role="tab" aria-controls="client" aria-selected="false">
                        <i class="far fa-user-circle pe-1"></i>
                        Контакты
                    </button>
                </li>
            </ul>

            <div class="tab-content" id="order-tabs-content">
                <div class="tab-pane fade show active" id="order" role="tabpanel" aria-labelledby="order-tab">
                    {#if
                        $user
                        && ($user.tip.toLowerCase().includes('администратор') || $user && $user.tip.toLowerCase().includes('менеджер'))
                        && !$cart_data.nomDocStr
                    }
                        <div class="row mb-1">
                            <div class="col-12">
                                <div class="input-wrapper">
                                    <label class="form-label" for="price_type">Тип цены</label>
                                    <select id="price_type" class="form-control form-select" bind:value={price_type}>

                                       <!-- // Настройки для Евгений Ставрополь	38-->
                                        {#if (APP_TYPE === 'axis-one' && parseInt($user.idSklad) === 38) }
                                            {#if $user && (!$user.tip.toLowerCase().includes('менеджер дилера'))}
                                                <option value="rozn" selected>Розничная цена</option>
                                            {/if}

                                        {:else}
                                            <option value="rozn" selected>Розничная цена</option>
                                        {/if}

                                        <option value="opt">Дилерская цена</option>

                                        {#if $user && $user.tip.toLowerCase().includes('администратор')}
                                            <option value="sebest">Закупочная цена</option>
                                        {/if}
                                    </select>
                                </div>
                            </div>
                        </div>
                    {/if}

                    {#if chutzpah}
                        <div class="row g-0 d-flex align-items-end mb-1">
                            <div class="col-5">
                                <div class="input-wrapper">
                                    <label class="form-label" for="markup_percent">Наценка</label>
                                    <input id="markup_percent" type="number" class="form-control" min="0" bind:value={$cart_data.markup_percent} on:change={handlerSaveCardData} />
                                </div>
                            </div>
                            <div class="col-5">
                                <div class="input-wrapper">
                                    <label class="form-label" for="discount_percent">Скидка</label>
                                    <input id="discount_percent" type="number" class="form-control" min="0" max="99" bind:value={$cart_data.discount_percent} on:change={handlerSaveCardData} />
                                </div>
                            </div>
                            <div class="col-2">
                                <button class="btn btn-icon btn-warning" on:click={() => doCalcDeal($cart_data.discount_percent)}>
                                    <i class="fas fa-calculator fa-fw"></i>
                                </button>
                            </div>
                        </div>

                        {@const total = _.sumBy($cart, (o) => +o.price[price_type] * +o.quantity)}
                        {@const markupAmount = total * ($cart_data.markup_percent / 100)}
                        {@const subtotalWithMarkup = total + markupAmount}
                        {@const discountAmount = subtotalWithMarkup * ($cart_data.discount_percent / 100)}
                        {@const finalTotal = subtotalWithMarkup - discountAmount}

                        {#if ($cart_data.markup_percent > 0) || ($cart_data.discount_percent > 0 && $cart_data.discount_percent <= 99)}
                            <div class="row">
                                <div class="col-6"><b>Базовая сумма:</b></div>
                                <div class="col-6" style="text-align: right">
                                    <p class="text-muted mb-0">{Math.round(total).toLocaleString()}₽</p>
                                </div>
                            </div>
                        {/if}
                        {#if $cart_data.markup_percent > 0}
                            <div class="row">
                                <div class="col-6"><b>Наценка:</b></div>
                                <div class="col-6" style="text-align: right">
                                    <p class="text-muted mb-0">+{Math.round(markupAmount).toLocaleString()}₽</p>
                                </div>
                            </div>
                        {/if}
                        {#if $cart_data.discount_percent > 0 && $cart_data.discount_percent <= 99}
                            <div class="row">
                                <div class="col-6"><b>Скидка:</b></div>
                                <div class="col-6" style="text-align: right">
                                    <p class="text-muted mb-0">–{Math.round(discountAmount).toLocaleString()}₽</p>
                                </div>
                            </div>
                        {/if}
                        <div class="row">
                            <div class="col-6"><b>Итого:</b></div>
                            <div class="col-6" style="text-align: right">
                                <p class="text-muted mb-0">{Math.round(finalTotal).toLocaleString()}₽</p>
                            </div>
                        </div>
                    {:else}
                        <div class="row">
                            <div class="col-6"><b>Сумма:</b></div>
                            <div class="col-6" style="text-align: right">
                                <p class="text-muted mb-0">{_.sumBy($cart, (o) => +o.price[price_type] * +o.quantity).toLocaleString()}₽</p>
                            </div>
                        </div>
                    {/if}

                    <hr class="my-2">

                    {#each $cart as tovar, index}
                        {@const price = calcDealPrice(tovar.price[price_type])}

                        <div class="row mt-1" data-id="{tovar.idTovar}" title="{tovar.title}">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-12">
                                                <b>{tovar.name}</b><br>
                                                <p class="text-muted mb-0" style="font-size: 11px; line-height: 1.0;">{@html tovar.subname.replaceAll('; ', '<br>')}</p>
                                            </div>
                                            <div class="col-12 text-muted" style="text-align: right">
                                                {#if tovar.quantity > 1}
                                                    {(+price).toLocaleString()}₽
                                                    &times;
                                                    {tovar.quantity}шт
                                                    =
                                                {/if}
                                                {(+price * +tovar.quantity).toLocaleString()}₽
                                            </div>
                                        </div>
                                    </div>

                                    {#if
                                        (
                                            APP_TYPE === 'profile-doors' &&
                                            !tovar.type.toLowerCase().includes('монтаж')
                                        ) || (
                                            !tovar.type.toLowerCase().includes('доставка') &&
                                            !tovar.type.toLowerCase().includes('монтаж') &&
                                            !tovar.type.toLowerCase().includes('услуги') &&
                                            !tovar.type.toLowerCase().includes('упаков')
                                        )
                                    }
                                        <div class="col-6">
                                            <button class="btn btn-secondary btn-sm w-100" on:click={() => handlerEdit(tovar.idTovar)}>
                                                <i class="far fa-edit pe-1"></i>
                                                Изменить
                                            </button>
                                        </div>
                                    {:else}
                                        <div class="col-6"></div>
                                    {/if}
                                    <div class="col-6">
                                        <button class="btn btn-danger btn-sm w-100" on:click={() => handlerRemove(index)}>
                                            <i class="fas fa-trash-alt pe-1"></i>
                                            Удалить
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/each}
                </div>

                <div class="tab-pane fade" id="client" role="tabpanel" aria-labelledby="client-tab">
                    <div class="row">
                        {#if APP_TYPE === 'axis-plisse' && $user && $user.tip.toLowerCase().includes('администратор')}
                            {#await network.fetch_proxy(`EXEC getUrlica @svoi = 0, @idSklad = ${+$user.idSklad}`) then data}
                                {@const list = data.map(({ idUrllico, name }) => ({ idUrllico, name }))}

                                <div class="col-12">
                                    <div class="input-wrapper">
                                        <label class="form-label" for="idKontr">Контрагент</label>
                                        <KontrSelectSearch items={list} defaults={$user.idkontr} on:select={({detail}) => idKontr = detail.id ?? $user.idkontr}/>
                                    </div>
                                </div>
                            {/await}

                            {#await network.fetch_proxy(`EXEC getKontakts @idKontr = ${+idKontr}`) then data}
                                {@const list = data.map(({ idKontakt, nameKontakt, telefonKontakt }) => ({ idKontakt, nameKontakt, telefonKontakt }))}

                                {#if data.length}
                                    {@const _ = handlerFillContact(data, data[0].idKontakt)}
                                {/if}

                                <div class="col-12">
                                    <div class="input-wrapper">
                                        <label class="form-label" for="idKontr">Имя</label>
                                        <KontaktSelectSearch items={list} bind:searchQuery={$cart_data.fio} on:select={({detail}) => handlerFillContact(data, detail.id)}/>
                                    </div>
                                </div>
                            {/await}
                        {:else}
                            <div class="col-12">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Имя</label>
                                        <input type="text" class="form-control" bind:value={$cart_data.fio} on:change={handlerSaveCardData}>
                                    </div>
                                </div>
                            </div>
                        {/if}

                        <div class="col-12">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Телефон <span class="text-danger">*</span></label>
                                    <div class="row">
                                        <div class="{$cart_data.tel ? 'col-8' : 'col-12'}">
                                            <input type="tel" class="form-control mx-0" bind:value={$cart_data.tel} on:change={handlerSaveCardData}>
                                        </div>
                                        {#if $cart_data.tel}
                                            <div class="col-2 text-center">
                                                <a class="btn btn-outline-light" target="_blank" href="tel:{$cart_data.tel}">
                                                    <i class="fas fa-phone-square-alt fa-2x text-dark"></i>
                                                </a>
                                            </div>
                                            <div class="col-2 text-center">
                                                <a class="btn btn-outline-light" target="_blank" href="https://api.whatsapp.com/send/?phone={$cart_data.tel}">
                                                    <i class="fab fa-whatsapp-square fa-2x text-success"></i>
                                                </a>
                                            </div>
                                        {/if}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">E-Mail</label>
                                    <input type="email" class="form-control" bind:value={$cart_data.email} on:change={handlerSaveCardData}>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Адрес</label>
                                    <textarea class="form-control" rows="3" bind:value={$cart_data.address} on:change={handlerSaveCardData}></textarea>
                                </div>
                            </div>
                        </div>
                        {#await fetchTv() then list}
                            {#if list.length && APP_TYPE !== 'setkipro'}
                                <div class="col-12">
                                    <div class="form-group boxed">
                                        <div class="input-wrapper">
                                            <label class="form-label">Точка выдачи</label>
                                            <select class="form-control form-select" class:is-invalid={is_tv_error} bind:value={$cart_data.tv} on:change={handlerSaveCardData}>
                                                <option value={-1} disabled selected>Не выбрано</option>
                                                {#each list as item (item.id)}
                                                    <option value={item.id}>{item.tv}</option>
                                                {/each}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            {/if}
                        {/await}
                        <div class="col-12">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Комментарий</label>
                                    <textarea class="form-control" rows="3" data-note="{$cart_data.note}" bind:value={$cart_data.comment} on:change={handlerSaveCardData}></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-2">
                        {#if $cart_data.nomDocStr}
                            <div class="col-6">
                                <button type="button" class="btn btn-primary btn-block" on:click={() => handlerSend(false)} disabled={is_disabled}>
                                    {#if is_disabled}
                                        {#if is_error}
                                            Ошибка!
                                        {:else}
                                            Отправляем..
                                        {/if}
                                    {:else}
                                        Сохранить #{$cart_data.nomDocStr ?? ''}
                                    {/if}
                                </button>
                            </div>
                            <div class="col-6">
                                <button type="button" class="btn btn-secondary btn-block" on:click={() => handlerSend(true)}>
                                    Новый
                                </button>
                            </div>
                            <div class="col-12 mt-1">
                                <button type="button" class="btn btn-danger btn-block btn-sm" on:click={handlerClear}>
                                    Очистить
                                </button>
                            </div>
                        {:else}
                            <div class="col-12">
                                <button type="button" class="btn {is_error ? 'btn-danger' : 'btn-primary'} btn-block btn-lg" on:click={handlerSend} disabled={is_disabled}>
                                    {#if is_disabled}
                                        {#if is_error}
                                            Ошибка!
                                        {:else}
                                            Отправляем..
                                        {/if}
                                    {:else}
                                        Создать заказ
                                    {/if}
                                </button>
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
        {:else}
            <div class="offcanvas-body text-center">
                <div class="row">
                    <div class="col-sm-12 empty-cart-cls text-center">
                        <img src="/img/cart_empty.png" width="130" height="130" class="img-fluid mb-4 mr-3">
                        <h3><strong>Корзина пуста</strong></h3>
                        <h4>Для начала нужно что-то добавить..</h4>
                    </div>
                </div>
            </div>
        {/if}
    </div>
</div>
<!-- * App OffCanvas -->

<div class="modal fade dialogbox" id="order-send" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-icon text-success">
                <i class="far fa-check-circle"></i>
            </div>

            {#if order_num}
                <div class="modal-header">
                    <h5 class="modal-title">Заказ отправлен</h5>
                </div>
                <p class="modal-body">Запишите номер вашего заказа: {order_num}</p>
            {:else}
                <div class="modal-header">
                    <h5 class="modal-title">Что-то пошло не так</h5>
                </div>
                <p class="modal-body">Ваш заказ не был отправлен</p>
            {/if}

            <div class="modal-footer">
                <div class="btn-inline">
                    <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                </div>
            </div>
        </div>
    </div>
</div>
